import { render, staticRenderFns } from "./ContactAvatar.vue?vue&type=template&id=2fb2713f"
import script from "./ContactAvatar.vue?vue&type=script&lang=js"
export * from "./ContactAvatar.vue?vue&type=script&lang=js"
import style0 from "./ContactAvatar.vue?vue&type=style&index=0&id=2fb2713f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports